import { LevelSurfacesLoadingPage } from "@-/dev.improve.haniverse.routes.nav.app._components.level.surface";
import { PageNavigatorRedirect } from "@-/dev.improve.haniverse.lib.navigator.page";
import {
  ToolbarActionsLane,
  ToolbarIconButton,
} from "@-/dev.improve.haniverse.components.ui.toolbar.button.icon";
import { useBrowseCharactersRankPageNavigator } from "@-/dev.improve.haniverse.routes.nav.app.browse.tabs.characters.navigator";
import { View } from "@-/com.npmjs.react-native";

/**
 * Characters tab entry: redirects to the destination Characters route (Rank) on the first render.
 * Immediate mode is safe here because the Rank page renders the static corpus-frequency catalog
 * (`@-/dev.improve.haniverse.data.graphemes-frequency`) — it never suspends on a data query, so there
 * is nothing to wait for before landing on it. The nav header + dataset-progress expansion are
 * rendered once by the layout above this Slot, so this page only fills the body.
 */
export function BrowseCharactersIndexPage() {
  const browseCharactersRankPageNavigator = useBrowseCharactersRankPageNavigator();

  return (
    <PageNavigatorRedirect
      navigator={browseCharactersRankPageNavigator}
      prefetchQueryKey="browseCharactersIndexPage"
    >
      <View className="flex-1 bg-background">
        <LevelSurfacesLoadingPage hasFloatingToolbar />
        <ToolbarActionsLane pointerEvents="none">
          <ToolbarIconButton
            accessibilityLabel="Loading characters"
            disabled
            isLoading
            name="MdRefresh"
            size="menu"
          />
        </ToolbarActionsLane>
      </View>
    </PageNavigatorRedirect>
  );
}
